import { createContext } from '@lit/context';
import { Store } from '@repobit/dex-store';

export type storeContextType = Store | undefined
export const storeContext = createContext<storeContextType>(Symbol('store'));